(function () {
  function initComparisonCarousel(root) {
    if (!root || root.dataset.comparisonCarouselInitialized === 'true') return;

    root.dataset.comparisonCarouselInitialized = 'true';

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

    var speed = parseInt(root.dataset.cycleSpeed, 10) || 2000;
    var cyclers = root.querySelectorAll('[data-image-cycler]');

    Array.prototype.forEach.call(cyclers, function (cycler) {
      var images = cycler.querySelectorAll('img');
      if (images.length <= 1) return;

      var currentIndex = 0;
      window.setInterval(function () {
        images[currentIndex].classList.remove('is-active');
        currentIndex = (currentIndex + 1) % images.length;
        images[currentIndex].classList.add('is-active');
      }, speed);
    });
  }

  function initAllComparisonCarousels(scope) {
    var roots = (scope || document).querySelectorAll('[data-comparison-carousel]');
    Array.prototype.forEach.call(roots, initComparisonCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      initAllComparisonCarousels(document);
    });
  } else {
    initAllComparisonCarousels(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    initAllComparisonCarousels(event.target);
  });
})();
